import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * Scrolls the main content area (.content inside the sidebar shell) to the top.
 * Falls back to window.scrollTo if the element is not found.
 */
@Injectable({ providedIn: 'root' })
export class ScrollService {
  private readonly document = inject(DOCUMENT);

  scrollToTop(): void {
    const content = this.document.querySelector<HTMLElement>('main.content');
    if (content) {
      content.scrollTo({ top: 0, behavior: 'instant' });
    } else {
      this.document.documentElement.scrollTo({ top: 0, behavior: 'instant' });
      this.document.defaultView?.scrollTo({ top: 0, behavior: 'instant' });
    }
  }
}
